var SimpleCarousel;
(function (SimpleCarousel) {
    myonce('simplecarousel', () => {
        const $carousels = document.querySelectorAll('.simple-carousel');
        if ($carousels.length) {
            $carousels.forEach($carousel => {
                let isMobile = window.innerWidth < 992; 
                let carouselSlides = $carousel.querySelectorAll('.slide');
                let slide = carouselSlides && carouselSlides.length && carouselSlides[0];
                let marginWidth = slide && parseInt((getComputedStyle(slide).marginRight || '0'));
                const leftControlArrow = $carousel.querySelector('.control-arrow-left');
                const rightControlArrow = $carousel.querySelector('.control-arrow-right');
                let currentIndex = 0;
                let slideClusterWidth = 0;
                const attrClusterSize = $carousel.getAttribute('data-cluster-size')
                    ? parseInt($carousel.getAttribute('data-cluster-size'))
                    : 1;
                const attrClusterSizeMobile = $carousel.getAttribute('data-cluster-size-mobile')
                    ? parseInt($carousel.getAttribute('data-cluster-size-mobile'))
                    : 1;
                let clusterSize = attrClusterSize;
                let slideWidth = slideClusterWidth / clusterSize;
                let carouselInterval;
                const getSlideSizes = () => {
                    isMobile = window.innerWidth < 992; 
                    slideClusterWidth =
                        $carousel.querySelector('.simple-carousel-box')
                            .clientWidth || 0;
                    clusterSize = isMobile
                        ? attrClusterSizeMobile
                        : attrClusterSize;
                    let slide = carouselSlides && carouselSlides.length && carouselSlides[0];
                    marginWidth = slide && parseInt(getComputedStyle(slide).marginRight || '0');
                    slideWidth = slideClusterWidth / clusterSize -
                        (marginWidth * (clusterSize - 1)) / clusterSize; 
                };
                getSlideSizes();
                const setSlide = newIndex => {
                    currentIndex = newIndex;
                    $carousel.getElementsByClassName('slide-container')[0].style.transform =
                        'translateX(calc(-' +
                            (slideClusterWidth + marginWidth) +
                            'px * ' +
                            newIndex +
                            '))';
                    let navItems = $carousel.getElementsByClassName('nav-item');
                    for (let index = 0; index < navItems.length; index++) {
                        navItems[index].className =
                            currentIndex === index
                                ? 'nav-item active'
                                : 'nav-item';
                    }
                };
                const prevSlide = () => {
                    setSlide((Math.ceil(carouselSlides.length / clusterSize) +
                        currentIndex -
                        1) %
                        Math.ceil(carouselSlides.length / clusterSize));
                };
                const nextSlide = () => {
                    setSlide((Math.ceil(carouselSlides.length / clusterSize) +
                        currentIndex +
                        1) %
                        Math.ceil(carouselSlides.length / clusterSize));
                };
                const setNavButtons = () => {
                    let nav = $carousel.getElementsByClassName('nav-buttons')[0];
                    if (Math.ceil(carouselSlides.length / clusterSize) > 1) {
                        for (let index = 0; index <
                            Math.ceil(carouselSlides.length / clusterSize); index++) {
                            let navItem = document.createElement('li');
                            navItem.className =
                                currentIndex === index
                                    ? 'nav-item active'
                                    : 'nav-item';
                            navItem.setAttribute('aria-label', 'card ' + index);
                            navItem.setAttribute('role', 'button');
                            navItem.tabIndex = 0;
                            navItem.addEventListener('click', function () {
                                stopCarouselAnimation();
                                setSlide(index);
                                startCarouselAnimation();
                            });
                            nav.appendChild(navItem);
                        }
                    }
                };
                const deleteNavButtons = () => {
                    let nav = $carousel.getElementsByClassName('nav-buttons')[0];
                    nav.innerHTML = '';
                };
                const setControls = () => {
                    if (leftControlArrow && rightControlArrow) {
                        if (Math.ceil(carouselSlides.length / clusterSize) > 1) {
                            leftControlArrow.classList.add('visible');
                            rightControlArrow.classList.add('visible');
                        }
                        else {
                            leftControlArrow.classList.remove('visible');
                            rightControlArrow.classList.remove('visible');
                        }
                    }
                };
                const startCarouselAnimation = () => {
                    carouselInterval = setInterval(() => {
                        nextSlide();
                    }, 4500);
                };
                const stopCarouselAnimation = () => {
                    clearInterval(carouselInterval);
                };
                const setSlideSize = () => {
                    getSlideSizes();
                    for (let index = 0; index < carouselSlides.length; index++) {
                        carouselSlides[index].style.width =
                            slideWidth + 'px';
                    }
                };
                const hammer = new Hammer($carousel);
                hammer.on('swipeleft', () => {
                    stopCarouselAnimation();
                    nextSlide();
                    startCarouselAnimation();
                });
                hammer.on('swiperight', () => {
                    stopCarouselAnimation();
                    prevSlide();
                    startCarouselAnimation();
                });
                setSlideSize();
                setSlide(currentIndex);
                setNavButtons();
                setControls();
                if (leftControlArrow) {
                    leftControlArrow.setAttribute('aria-label', 'Slide1');
                    leftControlArrow.addEventListener('click', () => {
                        stopCarouselAnimation();
                        prevSlide();
                        startCarouselAnimation();
                    });
                }
                if (rightControlArrow) {
                    rightControlArrow.setAttribute('aria-label', 'Slide1');
                    rightControlArrow.addEventListener('click', () => {
                        stopCarouselAnimation();
                        nextSlide();
                        startCarouselAnimation();
                    });
                }
                $carousel.addEventListener('mouseenter', () => {
                });
                $carousel.addEventListener('touchstart', () => {
                });
                $carousel.addEventListener('mouseleave', () => {
                });
                $carousel.addEventListener('touchend', () => {
                });
                window.addEventListener('resize', () => {
                    let oldIsMobile = isMobile;
                    setSlideSize();
                    if (oldIsMobile !== isMobile) {
                        currentIndex = 0;
                        deleteNavButtons();
                        setNavButtons();
                        setControls();
                        setSlide(currentIndex);
                    }
                    else {
                        setSlide(currentIndex);
                    }
                });
            });
        }
    });
})(SimpleCarousel || (SimpleCarousel = {}));
